<section
  id="login"
  *ngIf="settingsService.settings"
  [ngStyle]="{
    backgroundImage:
      'url(' + ('/assets/img/login-left-img.svg' | themed : 'loginScreen') + ')'
  }"
>
  <div class="left-image">
    <img
      [src]="'/assets/img/login-left-img.svg' | themed : 'loginScreen'"
      alt=""
      class="img-left"
    />
  </div>
  <div class="login-container">
    <form
      class="login-form"
      [formGroup]="form"
      *ngIf="form && !mfaNeeded && !emailCodeNeeded && !magicLinkCodeNeeded && !SMSCodeNeeded"
      (ngSubmit)="onSubmit()"
    >
      <h5 class="title" style="text-align: center; text-transform: uppercase;">{{"AccessWithoutPasswordTitle" | translate }}</h5>
      <p class="desc" style="text-align: center; margin-bottom: 20px;">
        {{"AccessWithoutPasswordDesc" | translate }}
      </p>
      <div class="form-group-login">
        <app-shared-form-input-text
          formControlName="magiclink"
          type="email"
          name="magiclink"
          email=""
          label="{{'AccessWithoutPasswordButton' | translate}}"
          placeholder="Email"
        ></app-shared-form-input-text>
        <button
          class="submit-btn"
          type="button"
          [disabled]="
            isLoading ||
            form.controls['magiclink'].invalid ||
            !form.controls['magiclink'].value
          "
          (click)="sendMagicLink()"
        >
          <div *ngIf="!isLoading">
            {{"AccessWithoutPasswordButton" | translate }}
          </div>
          <ng-container *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
          </ng-container>
        </button>
      </div>

      <!-- Acessar com telefone (SMS OTP) -->
      <div class="styled-divider" style="display: flex">
        <hr />
          {{"Or" | translate }}
        <hr />
      </div>

      <h5 class="title" style="text-align: center; text-transform: uppercase;">
        {{"AccessWithPhoneTitle" | translate }}
      </h5>
      <p class="desc" style="text-align: center; margin-bottom: 20px;">
        {{"AccessWithPhoneDesc" | translate }}
      </p>
      <div class="form-group-login">
        <div class="phone-field">
          <ngx-mat-intl-tel-input
            #phoneRef="ngModel"
            id="phoneinput"
            [preferredCountries]="preferredCountries"
            [enablePlaceholder]="true"
            [enableSearch]="true"
            name="authPhoneNumber"
            describedBy="phoneInput"
            [(ngModel)]="phoneValue"
            [ngModelOptions]="{standalone: true}"
          ></ngx-mat-intl-tel-input>
        </div>
        <div class="field-error" *ngIf="phoneRef.invalid && (phoneRef.touched || phoneRef.dirty)">
          {{ "InvalidPhoneNumber" | translate }}
        </div>
        <ng-container *ngIf="phoneAmbiguous">
          <p class="desc" style="text-align: center; margin-bottom: 8px;">
            {{ "PhoneAmbiguousDesc" | translate }}
          </p>
          <app-shared-form-input-text
            type="email"
            name="smsDisambiguateEmail"
            [label]="'Email'"
            placeholder="Email"
            [(ngModel)]="smsEmailValue"
            [ngModelOptions]="{standalone: true}"
          ></app-shared-form-input-text>
        </ng-container>
        <button
          class="submit-btn"
          type="button"
          [disabled]="isLoading || !phoneValue || phoneRef.invalid || (phoneAmbiguous && !smsEmailValue)"
          (click)="sendSMSCode()"
        >
          <div *ngIf="!isLoading">{{"SendSMS" | translate }}</div>
          <ng-container *ngIf="isLoading"><mat-spinner [diameter]="20"></mat-spinner></ng-container>
        </button>
      </div>

      <!-- Acessar com email/senha -->
      <div class="styled-divider" style="display: flex">
        <hr />
          {{"Or" | translate }}
        <hr />
      </div>

      <h5 class="title" style="text-align: center; text-transform: uppercase;">{{"AccessWithPasswordTitle" | translate }}</h5>
      <p class="desc" style="text-align: center; margin-bottom: 20px;">
        {{"AccessWithPasswordDesc" | translate }}
      </p>

      <div class="form-group-login">
        <app-shared-form-input-text
          formControlName="email"
          type="email"
          name="email"
          required=""
          email=""
          label="Email"
        ></app-shared-form-input-text>
        <app-shared-form-input-text
          formControlName="password"
          type="password"
          [passwordInput]="true"
          required=""
          name="password"
          label="{{'Password' | translate}}"
        ></app-shared-form-input-text>

        <div class="links-container">
          <p class="link forgot-password" routerLink="/auth/forgot">
            {{ "ForgotYourPassword" | translate }}
          </p>
        </div>

        <mat-checkbox class="remember" formControlName="rememberMe">
          {{ "RememberMe" | translate }}</mat-checkbox
        >

        <button
          class="submit-btn"
          type="submit"
          [disabled]="isLoading"
        >
          <ng-container *ngIf="!isLoading">{{ "AccessWithPasswordButton" | translate }}</ng-container>
          <ng-container *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
          </ng-container>
        </button>
      </div>
    </form>

    <form class="mfa-form" [formGroup]="mfaForm" *ngIf="mfaForm && mfaNeeded">
      <img src="/assets/img/mdr-Logo.svg" alt="" class="logo" />
      <h5 class="title">{{ "MFAcodechallenger" | translate }}</h5>
      <p class="desc">
        {{
          "Foraddedsecurity,pleaseverifyyouridentityusingMulti-FactorAuthentication(MFA).Enterthecodegeneratedbyyourauthenticatorappbelowtoproceed."
            | translate
        }}
      </p>
      <div class="form-group-login">
        <app-shared-form-code-challenger
          formControlName="code"
          type="code"
          name="code"
          label="MFA Code"
        ></app-shared-form-code-challenger>

        <button
          class="submit-btn mfa-btn"
          [disabled]="isLoading || form.invalid"
          (click)="submitMfa()"
        >
          <ng-container *ngIf="!isLoading">Sign In</ng-container>
          <ng-container *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
            Loading...
          </ng-container>
        </button>
      </div>
    </form>

    <form class="mfa-form" [formGroup]="emailCodeForm" *ngIf="emailCodeNeeded">
      <img src="/assets/img/mdr-Logo.svg" alt="" class="logo" />
      <h5 class="title">{{ "EmailVerification" | translate }}</h5>
      <p class="desc">
        {{
          "Pleasevalidateyouraccountbytypinginthecodeyoureceivedonyouremail."
            | translate
        }}
      </p>
      <div class="form-group-login">
        <app-shared-form-code-challenger
          formControlName="emailCode"
          type="code"
          name="emailCode"
          label="Email verification code"
        ></app-shared-form-code-challenger>

        <button
          class="submit-btn mfa-btn"
          [disabled]="isLoading"
          (click)="submitCode()"
        >
          <ng-container *ngIf="!isLoading">Sign In</ng-container>
          <ng-container *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
            Loading...
          </ng-container>
        </button>
      </div>
    </form>

    <!-- OTP SMS Code Form -->
    <form class="mfa-form" [formGroup]="OTPSmsCodeForm" *ngIf="SMSCodeNeeded">
      <button mat-icon-button class="step-back" (click)="stepSMSVerificationCodeLink()" type="button">
        <mat-icon svgIcon="curved-arrow-back"></mat-icon>
      </button>
      <h5 class="title">{{"VerifyYourPhone" | translate }}</h5>
      <p class="desc">{{"EnterSMSCode" | translate }}</p>
      <div class="form-group-login">
        <app-shared-form-code-challenger
          formControlName="smsCode"
          type="code"
          name="smsCode"
          label="SMS verification code"
        ></app-shared-form-code-challenger>
        <button class="submit-btn mfa-btn" [disabled]="isLoading" (click)="submitSMSCode()">
          <ng-container *ngIf="!isLoading">{{ "SignIn" | translate }}</ng-container>
          <ng-container *ngIf="isLoading"><mat-spinner [diameter]="20"></mat-spinner></ng-container>
        </button>
        <div class="text-center">
          <p *ngIf="countdown > 0">{{ "ResendCodeIn" | translate }} {{ countdownDisplay }}</p>
          <p *ngIf="countdown === 0"><a (click)="sendSMSCode()">{{ "DidntReceiveCodeResendSMS" | translate }}</a></p>
        </div>
      </div>
    </form>

    <form
      class="mfa-form"
      [formGroup]="magicLinkCodeForm"
      *ngIf="magicLinkCodeNeeded"
    >
      <button
        mat-icon-button
        class="step-back"
        (click)="stepBackMagicLink()"
        type="button"
      >
        <mat-icon svgIcon="curved-arrow-back"></mat-icon>
      </button>
      <h5 class="title">{{ "One-Timeaccesslink" | translate }}</h5>
      <p class="desc">
        {{ "OneTimeAccessLinkDesc" | translate }}
      </p>
      <div class="styled-divider" style="display: flex">
        <hr />
          {{"Or" | translate }}
        <hr />
      </div>
      <p class="desc">
        {{ "OneTimeAccessLinkCode" | translate }}
      </p>
      <div class="form-group-login">
        <app-shared-form-code-challenger
          formControlName="magicLinkCode"
          type="code"
          name="MagicLinkCode"
          label="MagicLink verification code"
        ></app-shared-form-code-challenger>

        <button
          class="submit-btn mfa-btn"
          [disabled]="isLoading"
          (click)="submitMagicLink()"
        >
          <ng-container *ngIf="!isLoading">{{
            "SignIn" | translate
          }}</ng-container>
          <ng-container *ngIf="isLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
            {{ "Loading..." | translate }}
          </ng-container>
        </button>
      </div>
    </form>
  </div>
</section>
